import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { TotalDispatchComponent } from './components/total-dispatch/total-dispatch.component';


const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'total-dispatch',
    component: TotalDispatchComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
